import React, { useState, useEffect, useRef } from 'react';
/** Components Import */
import { Button } from '../MUIs';

function TextToSpeech({
  onAudioPlayEnd,
  text,
  audioRef,
  ttsAudio,
  setTtsAudio,
}) {
  // const [blobUrl, setBlobUrl] = useState(null);
  // const audioRef = useRef(null); // 오디오 객체 참조

  // text 프롭이 변경될 때마다 TTS_Play 함수 호출
  useEffect(() => {
    // const timeout = setTimeout(() => {
    if (text !== '') {
      TTS_Play(text);
    }
    // }, 1000);

    // return () => clearTimeout(timeout);
  }, [text]); // text가 변경될 때마다 실행

  // Text To Speech Play
  const TTS_Play = async (text) => {
    const data = {
      voice: {
        languageCode: 'ko-KR',
        name: 'ko-KR-Standard-A',
      },
      input: {
        text: text,
      },
      audioConfig: {
        audioEncoding: 'mp3',
      },
    };

    try {
      // 환경변수에서 API 키가 없으면 오류를 발생시킴
      if (!process.env.REACT_APP_GOOGLE_API_KEY) {
        throw new Error(
          'REACT_APP_GOOGLE_API_KEY not found in the environment'
        );
      }

      // 참고: https://texttospeech.googleapis.com/v1/text:synthesize?key=구글_API_KEY
      const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
      const response = await fetch(
        `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const res = await response.json(); // response 응답해줄때 base64로 인코딩된 문자열을 반환해줌!
      const audioContent = res.audioContent; // base64 인코딩된 오디오 데이터
      const blob = base64ToBlob(audioContent, 'audio/mp3');
      setTtsAudio((prev) => [...prev, { gubun: 'blob', blob: blob }]);
      const url = URL.createObjectURL(blob);

      const audioFile = new Audio(url);
      audioRef.current = audioFile;

      if (audioRef.current) {
        audioRef.current.volume = 1;
      }

      // 오디오 재생 완료될 때까지 대기
      await new Promise((resolve) => {
        audioFile.onended = () => {
          URL.revokeObjectURL(url);
          resolve();
          if (onAudioPlayEnd) {
            onAudioPlayEnd();
          }
        };
        audioFile.play();
      });
    } catch (error) {
      alert('오류', '오류가 발생하였습니다. 관리자에게 문의해주세요.');
      console.error('There was an error!', error);
    }
  };

  // // 2. 오디오 OFF 및 권한 해제
  // const stopAudio = () => {
  // 	if (audioRef.current) {
  // 		audioRef.current.pause(); // 오디오 재생 멈춤
  // 		audioRef.current.currentTime = 0; // 오디오 재생 시간을 처음으로 설정
  // 	}
  // };

  // Base64 -> Blob 변환 함수
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  return (
    <div>
      {/* 실질적인 음성 데이터를 가지고 있는 input 태그 */}
      {/* <audio ref={audioRef} src={blobUrl} controls hidden/> */}
    </div>
  );
}

export default TextToSpeech;
